/**
 * ExistingDebtFooter - Footer Section for Existing Debt Inputs
 *
 * Contains:
 * - Clear all button
 * - Clear all confirmation dialog
 */

import { Box, Button, Dialog, HStack, Text } from '@chakra-ui/react';
import type React from 'react';

import type { ExistingDebtInputForm } from '~/types';

interface ExistingDebtFooterProps {
  values: ExistingDebtInputForm;
  showClearAllDialog: boolean;
  setShowClearAllDialog: (show: boolean) => void;
  onClearAll: () => void;
}

export const ExistingDebtFooter: React.FC<ExistingDebtFooterProps> = ({
  values,
  showClearAllDialog,
  setShowClearAllDialog,
  onClearAll,
}) => {
  return (
    <>
      {/* Clear Table Button - Below Table */}
      {values.payments.length > 0 && (
        <Box display="flex" justifyContent="flex-start" gap={2}>
          <Button
            size="sm"
            colorPalette="red"
            variant="outline"
            onClick={() => setShowClearAllDialog(true)}
          >
            Clear Table
          </Button>
        </Box>
      )}

      {/* Clear All Confirmation Dialog */}
      <Dialog.Root
        open={showClearAllDialog}
        onOpenChange={({ open }) => setShowClearAllDialog(open)}
      >
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Clear Table?</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>
                Are you sure you want to clear all payment data? This action cannot be undone.
              </Text>
            </Dialog.Body>
            <Dialog.Footer>
              <HStack gap={2}>
                <Button variant="outline" onClick={() => setShowClearAllDialog(false)}>
                  Cancel
                </Button>
                <Button colorPalette="red" onClick={onClearAll}>
                  Clear Table
                </Button>
              </HStack>
            </Dialog.Footer>
            <Dialog.CloseTrigger />
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    </>
  );
};
